import { Component, createRef } from "react";

export class InView extends Component {
    constructor(props) {
        super(props);

        this.containerRef = createRef();
        this.mode = "";
        this.scrolled = () => this.windowScrolled();
    }

    componentDidMount() {
        window.addEventListener("scroll", this.scrolled);
        this.windowScrolled();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.scrolled);
    }

    // may be a bit performance heavy, can use setTimeout to throttle it
    windowScrolled() {
        const position = this.containerRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (this.in_view(position, windowHeight)) {
            if (this.mode !== "inView") {
                this.mode = "inView";
    
                if (this.props.inView) {
                    this.props.inView();
                }
            }
        }
        else if (this.mode !== "notInView") {
            this.mode = "notInView";

            if (this.props.notInView) {
                this.props.notInView();
            }
        }
    }

    in_view(position, windowHeight) {
        const offset = this.props.offset || 0;

        const isNotAboveView = position.top + position.height >= 0 + offset;
        const isNotBelowView = position.top <= windowHeight + offset;

        return isNotAboveView && isNotBelowView;
    }

    render() {
        return (
            <div className={this.props.class} ref={this.containerRef}>
                { this.props.children }
            </div>
        )
    }
}